import { FBXLoader } from "three/examples/jsm/loaders/FBXLoader";
import { Scene, MeshStandardMaterial, Vector3, Group, Mesh } from "three";

interface PropsConfig {
  mesh?: Mesh;
  position: Vector3;
  rotation: Vector3;
  scale: Vector3;
  fbxFileName?: string;
  material?: MeshStandardMaterial;
}

class PropsManager {
  private scene: Scene;

  constructor(scene: Scene) {
    this.scene = scene;
  }

  public addProp(config: PropsConfig, layer:number=1): void {
    if (config.mesh != null) {
      const clonedMesh = config.mesh.clone();
      clonedMesh.scale.copy(config.scale);
      clonedMesh.rotation.setFromVector3(config.rotation); // Clone the mesh
      clonedMesh.position.copy(config.position);
      clonedMesh.layers.set(layer);
      
      
      if (config.material != null) {
        clonedMesh.traverse((child) => {
          if ((child as Mesh).isMesh) {
            child.layers.set(layer);
            const m = child as Mesh;
            m.material = config.material;
            m.castShadow = true;
            m.receiveShadow = true;
          }
        });
      }
      else {

        clonedMesh.traverse((child) => {
          if ((child as Mesh).isMesh) {
            const m = child as Mesh;
            m.layers.set(layer);
            m.castShadow = true;
            m.receiveShadow = true;
          }
        });
      }


      this.scene.add(clonedMesh); // Add the cloned mesh to the scene
    } else {
      const fbxLoader = new FBXLoader();
      const { position, rotation, scale, fbxFileName, material } = config;
  
      fbxLoader.load(
        fbxFileName,
        (object: Group) => {
          object.traverse((child) => {
            if ((child as Mesh).isMesh) {
              const m = child as Mesh;
              m.material = material;
              m.castShadow = true;
              m.receiveShadow = true;
            }
          });
  
          object.position.copy(position);
          object.rotation.setFromVector3(rotation);
          object.scale.copy(scale);
  
          this.scene.add(object);
        },
        (xhr) => {
          console.log((xhr.loaded / xhr.total) * 100 + "% loaded");
        },
        (error) => {
          console.error(error);
        }
      );
    }
  }
  
}

export default PropsManager;